const resetProjectState = state => {
  state.accountAvailable = false
  state.accountLoaded = false
  state.account = null
  state.accountLoading = false
  state.accountError = ''
  state.achAvailable = false
  state.fundingMethod = null
  state.achLoading = false
  state.achError = ''
}

export default {
  START_PROJECT_LOAD(state, projectId) {
    state.loadGeneration += 1
    state.projectId = projectId
    resetProjectState(state)
    state.accountLoading = true
  },

  RESET_PROJECT_STATE(state) {
    state.loadGeneration += 1
    state.projectId = null
    resetProjectState(state)
  },

  SET_ACCOUNT_RESULT(state, { available, account }) {
    state.accountAvailable = available
    state.accountLoaded = true
    state.account = account
    state.accountError = ''
  },

  SET_ACCOUNT_LOADING(state, loading) {
    state.accountLoading = loading
  },

  SET_ACCOUNT_ERROR(state, message) {
    state.accountLoaded = true
    state.accountError = message
  },

  SET_ACH_RESULT(state, { available, fundingMethod }) {
    state.achAvailable = available
    state.fundingMethod = fundingMethod
    state.achError = ''
  },

  SET_FUNDING_METHOD(state, fundingMethod) {
    state.fundingMethod = fundingMethod
  },

  SET_ACH_LOADING(state, loading) {
    state.achLoading = loading
  },

  SET_ACH_ERROR(state, message) {
    state.achError = message
  }
}
